import {Spinner} from 'react-bootstrap';
import {wrap, type GetProps} from 'src/components/util/Controls/wrap';

export const BootstrapSpinner = wrap(Spinner);
export type BootstrapSpinnerProps = GetProps<typeof BootstrapSpinner>;
